import React from 'react'
import { Link } from 'gatsby'
import './cbslideshow.css'
//import { Link } from 'gatsby'
//import { Modal, ModalHeader, ModalBody } from 'reactstrap'
//import Iframe from 'react-iframe'
//import window from 'global'

let banner = require('../../data/herobanner.json')

class Hero extends React.Component {
  render() {
    return (
      <div id="hero">
        <div className="hero home">
          <ul className="list-unstyled cb-slideshow">
            {banner.map((a, index) => (
              <li key={index}>
                <span
                  style={{
                    backgroundImage: `url(${a.src})`,
                    backgroundColor: '#000',
                  }}
                />
              </li>
            ))}
          </ul>

          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-xl-11 mx-auto">
                <div className="hero-content text-center">
                  <div className="herocontent sildertxt text-center">
                    <h3 className="txt1">Armstrong Real Estate Company</h3>
                    <h1 className="txt2">
                      The Best Way to Find Your
                      <br />
                      Perfect Home
                    </h1>
                    <p>
                      <Link
                        to="/contact"
                        className="findagnt_btn hvr-ripple-out"
                      >
                        {/* <svg
													style={{ width: '24px', height: '24px' }}
													viewbox="0 0 24 24"
												>
													<path
														fill="#fff"
														d="M16,13C15.71,13 15.38,13 15.03,13.05C16.19,13.89 17,15 17,16.5V19H23V16.5C23,14.17 18.33,13 16,13M8,13C5.67,13 1,14.17 1,16.5V19H15V16.5C15,14.17 10.33,13 8,13M8,11A3,3 0 0,0 11,8A3,3 0 0,0 8,5A3,3 0 0,0 5,8A3,3 0 0,0 8,11M16,11A3,3 0 0,0 19,8A3,3 0 0,0 16,5A3,3 0 0,0 13,8A3,3 0 0,0 16,11Z"
													/>
												</svg>{' '} */}
                        Contact Us
                      </Link>
                    </p>
                  </div>
                </div>
                <div className="arrowslid text-center">
                  <div className="arrow arrow-1" />
                  <div className="arrow arrow-2" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Hero
